import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const TrendArrowDownIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                fillRule='evenodd'
                clipRule='evenodd'
                d='M17 7V17H7L7.02994 15.2036L13.991 15.2186L6.38623 7.61377L7.61377 6.38623L15.2186 13.991L15.2335 7L17 7Z'
                fill='currentColor'
            />
        </>
    ),
})

TrendArrowDownIcon.displayName = 'TrendArrowDownIcon'
